import script from "./fw04_ArticleLists_New.vue?vue&type=script&setup=true&lang=js"
export * from "./fw04_ArticleLists_New.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__